import React from 'react'
import {
  CarouselProvider,
  Slider,
  Slide
} from 'pure-react-carousel'

import Image from '@/UI/Image'
import {
  StyledCarousel,
  StyledCarouselSlide
} from './styles'

import CarouselNavigation from './Navigation'

const Carousel = ({
  slides,
  objectFit
}) => (
  <StyledCarousel>
    <CarouselProvider
      totalSlides={slides?.data?.length}
    >
      <Slider>
        {
          slides?.data?.map((slide, index) => (
            <Slide key={index} index={index}>
              <StyledCarouselSlide fit={objectFit}>
                <Image data={slide} alt={slide?.attributes?.alternativeText || ''} />
              </StyledCarouselSlide>
            </Slide>
          ))
        }
      </Slider>
      {
        !!slides.data.length &&
        slides.data.length > 1 &&
        <CarouselNavigation />
      }
    </CarouselProvider>
  </StyledCarousel>
)

export default Carousel
